module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title'), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "pc0"
  }, [_c('i', [_vm._v("A Selection of Recent Titles by Judith Cutler")])]), _vm._v(" "), _c('p', {
    staticClass: "pc3"
  }, [_c('i', [_vm._v("The Lina Townend Series ")])]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("DRAWING THE LINE")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("SILVER GUILT *")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("RING OF GUILT *")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("GUILTY PLEASURES *")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("GUILT TRIP *")]), _vm._v(" "), _c('p', {
    staticClass: "pc3"
  }, [_c('i', [_vm._v("The Frances Harman Series")])]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("LIFE SENTENCE")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("COLD PURSUIT")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("STILL WATERS")]), _vm._v(" "), _c('p', {
    staticClass: "pc3"
  }, [_c('i', [_vm._v("The Josie Welford Series")])]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("THE FOOD DETECTIVE")]), _vm._v(" "), _c('p', {
    staticClass: "pc"
  }, [_vm._v("THE CHINESE TAKEOUT")]), _vm._v(" "), _c('p', {
    staticClass: "pc4"
  }, [_c('i', [_vm._v("* available from Severn House")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ca0da0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/alsoby.vue
// module id = 63
// module chunks = 0